<script lang="ts">
    import Fa from 'svelte-fa'
    import { FormTemplateItem } from '../../../modules/toolsApi/forms/form-templates/form-template-item'
    import { faClone, faCaretLeft, faCheck, faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import { FormDataContent } from '../../../modules/toolsApi/forms/form-datas/form-data-content'
    import TinyCustom from './tiny-custom.svelte'
    let dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let item: FormTemplateItem
    export let editable: boolean
    export let value: FormDataContent = new FormDataContent()
    export let view = false

    let step = 0
    let locallabel = ''
    let localRequired = true
    let localLocked = false

    function emitChange() {
        dispatch('change')
    }

    function goEdit() {
        locallabel = item.label || ''
        localRequired = item.required
        localLocked = item.locked
        step = 2
        dispatch('edit', true)
    }

    function goRemove() {
        item = null
        dispatch('remove')
    }

    function goCancel() {
        dispatch('edit', false)
        step = 1
    }

    let isNew = false
    onMount(async () => {
        isNew = editable && !item.label?.length
        if (isNew) {
            goEdit()
        } else {
            step = 1
        }
        await tick()
    })

    function goSave() {
        if (locallabel.trim().length === 0) {
            window.error('Informe o texto a ser adicionado')
            return
        }
        item.label = locallabel
        item.required = localRequired
        item.locked = localLocked
        item.score = false
        dispatch('edit', false)
        dispatch('change')
        step = 1
    }

    function goClone() {
        dispatch('clone', item)
    }
</script>

<div class="cs_element cs_input_line cs_element-editable-{editable} {className}" class:draggable={step === 1}>
    {#if step === 1}
        {#if editable}
            <div class="acts acts_1 acts-absolute">
                <div class="spacer"></div>
                <button on:click={goClone} title="Clique para duplicar este elemento" class="btn btn-sm btn-secondary me-2"><Fa icon={faClone}></Fa></button>
                <button on:click={goEdit} class="btn btn-sm btn-warning"><Fa icon={faEdit}></Fa></button>
            </div>
        {/if}
    {:else}
        <div class="acts acts_2 acts-absolute">
            <div class="spacer"></div>
            <div class="btn-group">
                <button on:click={goRemove} class="btn btn-sm btn-warning"><Fa icon={faTrash}></Fa>&nbsp;Excluir</button>
                {#if !isNew}
                    <button on:click={goCancel} class="btn btn-sm btn-secondary"><Fa icon={faCaretLeft}></Fa>&nbsp;Cancelar</button>
                {/if}
                <button on:click={goSave} class="btn btn-sm btn-primary"><Fa icon={faCheck}></Fa>&nbsp;Confirmar</button>
            </div>
        </div>
    {/if}

    {#if step === 1}
        <div class="cs_element_content">
            <div class="cs_item_title content_question">
                {@html item.label || ''}
            </div>
            {#if view}
                <div class="content_answer">
                    {@html value.value}
                </div>
            {:else}
                <div class="content_answer">
                    <TinyCustom allowImage={false} bind:value={value.value}></TinyCustom>
                </div>
            {/if}
        </div>
    {:else}
        <label for="" class="cs_item_title edit_question">Pergunta / Enunciado</label>
        <div class="input-inline">
            <input type="text" bind:value={locallabel} class="" />
            <div class="form-check form-switch cs-w-150">
                <input class="form-check-input" bind:checked={localRequired} type="checkbox" role="switch" id="localRequired" />
                <label class="form-check-label" for="localRequired">obrigatório</label>
            </div>
            <div class="form-check form-switch cs-w-150">
                <input class="form-check-input" bind:checked={localLocked} type="checkbox" role="switch" id="localLocked" />
                <label class="form-check-label" for="localLocked">Apenas leitura</label>
            </div>
        </div>
    {/if}
</div>
